import React from 'react';

import BenchmarksListScreen from './BenchmarksListScreen';

export default class BenchmarksRecommendationsScreen extends React.Component {
  render() {
    return <BenchmarksListScreen showRecommendations={true} />;
  }
}
